import type { JSX } from 'react';

import { Box, Container } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import recipientData from '../recipientData.json';

export function RecipientSection(): JSX.Element {
	return (
		<Box py={32} sx={{ backgroundColor: '#fdf9f2' }}>
			<Container px={[8, 16]} sx={{ height: '100%' }}>
				<Box>
					<Heading as="h2" size="h3" py={8}>
						Change.org’s Racial Justice Fund grants were awarded to the following organizations:
					</Heading>
					<Box as="ul" p={8} sx={{ columnCount: [2, 3] }}>
						{recipientData.map((r) => (
							<Box as="li" ml={16} key={r} sx={{ display: 'list-item', listStyleType: 'disc' }}>
								<Text>{r}</Text>
							</Box>
						))}
					</Box>
				</Box>
			</Container>
		</Box>
	);
}
